/**
 *
 * FlexInput
 *
 */

import React, { useRef, useState, useCallback } from 'react';
import styles from './styles.module.css';
import { FlexBox } from 'components/common';

function FlexInput(props) {
  const {
    style,
    disabled,
    rightGutter,
    leftGutter,
    topGutter,
    bottomGutter,
    guttered,
    gutter = 10,
    align,
    justify,
    fill,
    vstretch,
    hstretch,
    fluid,
    value,
    defaultValue,
  } = props;

  const labelRef = useRef(null);
  const inputRef = useRef(null);
  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);

  let elemStyle = style ? { ...style } : {};
  // if (rightGutter || guttered) {
  //   elemStyle.marginRight = `${gutter}px`
  // }

  // if (bottomGutter || guttered) {
  //   elemStyle.marginBottom = `${gutter}px`
  // }

  // if (leftGutter || guttered) {
  //   elemStyle.marginLeft = `${gutter}px`
  // }

  // if (topGutter || guttered) {
  //   elemStyle.marginTop = `${gutter}px`
  // }

  if (align) {
    elemStyle.alignItems = align;
  }

  if (justify) {
    elemStyle.justifyContent = justify;
  }

  if (fill) {
    elemStyle.height = '100%';
    elemStyle.width = '100%';
  }

  if (vstretch) {
    elemStyle.height = '100%';
    elemStyle.overflowY = 'auto';
  }

  if (hstretch || fluid) {
    elemStyle.width = '100%';
  }

  if (disabled) {
    elemStyle.opacity = 0.8;
    elemStyle.pointerEvents = 'none';
    elemStyle.border = 'none';
    elemStyle.boxShadow = 'none';
    elemStyle.textOverflow = 'ellipsis';
    elemStyle.paddingRight = 10;
  }

  function handleChange(e) {
    if (props.onChange) {
      props.onChange(e);
    }
  }

  function handleBlur(e) {
    if (props.onBlur) {
      props.onBlur(e);
    }
  }

  let labelStyle = props.labelStyle ? { ...props.labelStyle } : {};
  if (props.label) {
    if (props.labelPosition !== 'right') {
      if (labelRef && labelRef.current && inputRef && inputRef.current) {
        let bounds = labelRef.current.getBoundingClientRect();
        let inputBounds = inputRef.current.getBoundingClientRect();
        if (bounds && bounds.width !== 0) {
          elemStyle.textIndent = bounds.width + 10;
          labelStyle.height = inputBounds.height - 6;
        } else {
          setTimeout(() => {
            forceUpdate();
          }, 10);
        }
      } else {
        setTimeout(() => {
          forceUpdate();
        }, 10);
      }
    } else {
      if (labelRef && labelRef.current && inputRef && inputRef.current) {
        let bounds = labelRef.current.getBoundingClientRect();
        let inputBounds = inputRef.current.getBoundingClientRect();
        if (bounds && bounds.width !== 0) {
          labelStyle.height = inputBounds.height - 6;
          labelStyle.left = inputBounds.width - bounds.width - 3;
        } else {
          setTimeout(() => {
            forceUpdate();
          }, 10);
        }
      } else {
        setTimeout(() => {
          forceUpdate();
        }, 10);
      }
    }
  } else {
  }

  return (
    <FlexBox
      gutter={gutter}
      rightGutter={rightGutter}
      leftGutter={leftGutter}
      topGutter={topGutter}
      bottomGutter={bottomGutter}
      guttered={guttered}
      hstretch={fluid || hstretch}
      style={{ position: 'relative' }}
      row
      align="stretch"
    >
      {props.label && (
        <div style={labelStyle} ref={labelRef} className={styles.flexInputLabel}>
          {props.label}
        </div>
      )}
      <input
        ref={inputRef}
        value={value}
        defaultValue={defaultValue}
        style={elemStyle}
        className={styles.flexInputBox}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={props.placeholder}
      />
    </FlexBox>
  );
}

FlexInput.propTypes = {};

export default FlexInput;
